import {connect} from 'react-redux';
import {onNameYourPriceEnteredAction} from '../../store/actions';
import {currencySelector, maxPriceSelector, priceSelector} from '../../store/selectors/price.selector';
import {entityTypeSelector} from '../../services/albumProvider/albumProviderSelector';
import {NameYourPrice} from './NameYourPrice';

const mapStateToProps = (store) => ({
  entityType: entityTypeSelector(store),
  minPrice: priceSelector(store),
  maxPrice: maxPriceSelector(store),
  currency: currencySelector(store),
});

const mapDispatchToProps = {onContinue: onNameYourPriceEnteredAction};

export const NameYourPriceContainer = connect(mapStateToProps, mapDispatchToProps)(NameYourPrice);
